import { useState, useEffect, useRef } from 'react';
import styles from './addskumessage.module.scss';

/* Types */
import { SkuMessaging } from 'types/sku.types';

const AddSkuMessage = ({ bullets = [] }: Pick<SkuMessaging, 'bullets'>) => {
  const [bulletHeight, setBulletHeight] = useState(0);
  const bulletContainer = useRef<HTMLDivElement>(null);
  const height = `${bulletHeight}px`;
  const list = bullets.map(bullet => (
    <li key={bullet}>
      <p className="p1">{bullet}</p>
    </li>
  ));

  useEffect(() => {
    if (bulletContainer.current?.clientHeight) {
      setBulletHeight(bulletContainer.current?.clientHeight);
    }
  }, []);

  return (
    <div className={styles.bulletsContainer} style={{ height }}>
      <div ref={bulletContainer} className={styles.bulletsContent}>
        <h4>IMPORTANT:</h4>
        <ul>{list}</ul>
      </div>
    </div>
  );
};

export default AddSkuMessage;
